import React, { createContext, useContext, useState } from "react";
import { GlobalSnackNotify } from "./globalSnackNotify";

interface GlobalSnackbarNotifyProps {
  showSnackbar: (
    message: string,
    severity: "success" | "error" | "info"
  ) => void;
}

const GlobalSnackbarNotifyContext =
  createContext<GlobalSnackbarNotifyProps | null>(null);

export const SnackbarProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success" as "success" | "error" | "info",
  });
  const showSnackbar = (
    message: string,
    severity: "success" | "error" | "info"
  ) => {
    setSnackbar({ open: true, message, severity });
  };

  return (
    <GlobalSnackbarNotifyContext.Provider value={{ showSnackbar }}>
      {children}
      <GlobalSnackNotify
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      />
    </GlobalSnackbarNotifyContext.Provider>
  );
};

export const useSnackbarContext = (): GlobalSnackbarNotifyProps => {
  const context = useContext(GlobalSnackbarNotifyContext);
  if (!context) {
    throw new Error("Error in GlobalSnackbarNotifyContext");
  }
  return context;
}
